import { Box, Checkbox, DialogActions, DialogTitle, FormControlLabel, TextField } from "@mui/material";
import { Save, Close, PointOfSale } from "@mui/icons-material";
import { useRef, useState, useImperativeHandle, forwardRef, FormEvent, ChangeEvent } from "react"
import api from "../../../../Services/api";
import { useToast } from "../../../../Hooks/toast";
import { DialogContainer, DialogBox } from "../../../../Components/Atoms/BalanceWarning/styles";
import { Button as AppButton } from "../../../../Components/Atoms/Button";


export type OrginizerFormRef = {
    openOrganizer: (props: { name: string, subAccountId: string, isActive: boolean }) => void;
}

export const OrganizerForm = forwardRef<OrginizerFormRef,{ onSucess: VoidFunction }>(({ onSucess = () => {} }, ref) => {
    const [open, setOpen] = useState(false);

    const [subAccount, setSubAccount] = useState({
        subAccountId: '',
        name: '',
        isActive: true
    });

    const { addToast } = useToast();

    const [isLoading, setIsLoading] = useState(false);

    useImperativeHandle(ref, () => ({
        openOrganizer({ name = '', subAccountId = '', isActive = true }) {
            setSubAccount({
                name,
                subAccountId,
                isActive
            })
            setOpen(true);
        }
    }), [open])

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const name = e.currentTarget.name;
        const value = e.currentTarget.type == 'checkbox' ? e.currentTarget.checked : e.currentTarget.value;

        setSubAccount(oldSubAccount => ({ ...oldSubAccount, [name]: value}));
    }

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();

        try {
            setIsLoading(true);

            if(subAccount.subAccountId) {
                await api.put(`/subaccount/${subAccount.subAccountId}`, {
                    name: subAccount.name,
                    isActive: subAccount.isActive
                });
            }
            else {
                await api.post('/subaccount', {
                    name: subAccount.name
                });
            }

            addToast({
                title: "Sucesso",
                description: "Ponto de venda salvo com sucesso",
                type: 'success'
            })
    
            setOpen(false);            
        }
        finally {
            setIsLoading(false);
            onSucess();
        }

    }

    return (
        <DialogContainer open={open} onClose={() => setOpen(false)}>
            <DialogTitle sx={{ fontSize: '1.25rem', py: 1.5 }}>
                <PointOfSale fontSize="medium" />
                {subAccount.subAccountId ? 'Editar Ponto de Venda' : 'Adicionar Ponto de Venda'}
            </DialogTitle>
            <DialogBox>
                <Box onSubmit={handleSubmit} id="frmSubAccount" component='form' sx={{ width: '520px', p: 3 }}>
                    <TextField
                        size="small"
                        fullWidth
                        name="name"
                        value={subAccount.name}
                        onChange={handleChange}
                        label="Nome do Ponto de Venda"
                        helperText="Como este PV será identificado (ex.: Caixa 01 - Loja Centro)"
                        InputLabelProps={{ sx: { fontSize: '1.05rem' } }}
                        inputProps={{ style: { fontSize: '1.05rem' } }}
                        sx={{ mb: 2 }}
                    />
                    <FormControlLabel
                        sx={{ '& .MuiFormControlLabel-label': { fontSize: '1.05rem' } }}
                        label="Ponto de venda ativo"
                        control={
                            <Checkbox
                                disabled={!subAccount.subAccountId}
                                name="isActive"
                                checked={subAccount.isActive}
                                onChange={handleChange}
                            />
                        }
                    />
                </Box>
            </DialogBox>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <AppButton
                    action="cancel"
                    type='button'
                    onClick={() => setOpen(false)}
                    fontSize="1.05rem"
                >
                    <Close fontSize="small" /> Cancelar
                </AppButton>
                <AppButton
                    form="frmSubAccount"
                    type='submit'
                    loading={isLoading}
                    disabled={!subAccount.name || isLoading}
                    fontSize="1.05rem"
                >
                    <Save fontSize="small" /> Salvar
                </AppButton>
            </DialogActions>
        </DialogContainer>
    )
})